<template>
  <div style="background: #2b3c4c">
    <div class="dashboard-wrap" style="background: #2b3c4c!important">
      <!-- 顶部标题栏 -->
      <div class="top-header" style="background: #2b3c4c">
        <div class="header-title">印刷设备数据监管</div>
        <div class="header-time">
          <span class="time-icon"><!--        <img src="../assets/img/time-top.png" alt="">--></span>{{ overview.date }}

        </div>
      </div>

      <div class="main-container" style="background: linear-gradient(180deg, #2b3c4c 0%, #5a6672 100%);">
        <!-- 右侧设备卡片网格 -->
        <div class="machine-grid"  :class="{ 'grid-4': overview.deviceInfo.length > 9 }">
          <div
              class="machine-card"
              v-for="(item, index) in overview.deviceInfo"
              :key="index"
              style="background-color: #364f65"
          >
            <div class="card-head">
              <div class="machine-name">{{ item.name }}</div>
              <div class="status-tag"
                   :class="isItemRunning(item) ? 'tag-run' : item.state === 0 ? 'tag-test' : item.state === 1 ? 'tag-run' : 'tag-error'">
                {{ isItemRunning(item) ? '运行中' : item.state === 0 ? '待机中' : item.state === 1 ? '运行中' : '未开机' }}
              </div>
<!--              <div class="status-tag" :class="item.state === 0  ? 'tag-test' : item.state === 1 ? 'tag-run' : 'tag-error'">{{ item.state === 0 ? '待机中' : item.state === 1 ? '运行中' : '未开机' }}</div>-->
            </div>
            <div class="param-row">
              <div class="param-left">
                <div class="param-line"><div>保养提醒: </div><span>{{ item.maintain }}</span></div>
                <div class="param-line"><div>PH:</div><span>{{ item.ph }}</span></div>
                <div class="param-line"><div>电导率: </div><span>{{ item.ddl }} μS/cm</span></div>
                <div class="param-line"><div>水温:</div><span>{{ item.wd }} ℃</span></div>
              </div>
              <div class="border"></div>
              <div class="param-right">
                <div class="param-line"><div>日印数:</div><span>{{ item.count }}</span></div>
                <div class="param-line"><div>试印数:</div><span>{{ item.noCount }}</span></div>
                <div class="param-line"><div>运行时长:</div><span>{{ item.time }}h</span></div>
              </div>
            </div>
            <div class="card-bottom-num">{{ formatSpeed(item.speed) }}</div>
          </div>
        </div>
        <!-- 左侧侧边栏 -->
        <div class="left-aside">
          <!-- 设备总览模块 -->
          <div class="aside-card">
            <div class="card-subtitle">设备总览</div>
            <div class="total-device-box">
              <div class="total-text">设备总数</div>
              <div class="total-num">{{ overview.allCount }} <span>台</span></div>
              <div class="cube-img"></div>
            </div>
            <!-- 状态网格 -->
            <div class="status-grid">
              <div class="status-item ">
                <span>运行中</span>
                <span class="num run">{{ overview.yunXingCount }}<span>台</span></span>
              </div>
              <!--            <div class="status-item ">-->
              <!--              <span>试印中</span>-->
              <!--              <span class="num test">{{ overview.test }}<span>台</span></span>-->
              <!--            </div>-->
              <div class="status-item ">
                <span>停机中</span>
                <span class="num stop">{{ overview.tingJiCount }}<span>台</span></span>
              </div>
              <!--            <div class="status-item ">-->
              <!--              <span>故障中</span>-->
              <!--              <span class="num error">{{ overview.error }}<span>台</span></span>-->
              <!--            </div>-->
              <div class="status-item ">
                <span>保养中</span>
                <span class="num maintain">{{ overview.baoYangCount }}<span>台</span></span>
              </div>
              <div class="status-item ">
                <span>空闲中</span>
                <span class="num idle">{{ overview.kongXianCount }}<span>台</span></span>
              </div>
            </div>
          </div>

          <!-- 日印数统计模块 -->
          <div class="aside-card">
            <div class="card-subtitle card-subtitle2">日印数统计</div>
            <div class="card-box">
              <div class="stat-item">
                <span class="stat-label"><!--<img src="../assets/img/icon-number.png" alt="">--> 日印刷数:</span>
                <span class="stat-value">{{ overview.count }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label"><!--<img src="../assets/img/yinshu.png" alt="">--> 日试印数:</span>
                <span class="stat-value">{{ overview.noCount }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label"><!--<img src="../assets/img/icon-item.png" alt="">--> 日运行时长:</span>
                <span class="stat-value">{{ overview.time }}h</span>
              </div>
            </div>

          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";

export default {
  name: 'PrintMachineDashboard',
  data() {
    return {
      timer: null,
      timerData: null,   // 接口刷新定时器
      lastDateTime: 0,
      // 左侧设备总览数据
      overview: {
        allCount: 0,
        yunXingCount: 0,
        tingJiCount: 0,
        kongXianCount: 0,
        baoYangCount: 0,
        count: 0,
        noCount: 0,
        time: '',
        date: '',
        deviceInfo: []
      },

      // 9台设备完整列表
      machineList: [],

      // 串口相关
      serialData: '--',
      serialDataC: 0,
      lastValidC: null,
      serialTimeoutTimer: null,
    }
  },
  computed: {
    // 根据设备数量返回 grid 列数
    gridColumns() {
      return this.overview.deviceInfo.length <= 9 ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)'
    },
    // 日印刷数
    dayPrintCount() {
      const v = Number(this.serialDataC)
      if (isNaN(v) || this.serialDataC === '等待串口数据…') {
        return this.baseAllCount
      }
      return Math.max(0, v - this.baseAllCount)
    },
    // sumAllCount() {
    //   return this.overview.deviceInfo.reduce((sum, item) => {
    //     return sum + (Number(item.count) || 0)
    //   }, 0)
    // }
  },
  mounted() {
    window.onSerialData = this.handler
    this.getDaPingJiTaiDaNaLi()
    this.timerData = setInterval(() => {
      this.getDaPingJiTaiDaNaLi()
    }, 10000 * 6) // 10 秒
    this.timer = setInterval(() => {
      this.addOneSecond()
    }, 1000)
    // 可开启设备数据轮询
    // this.pollMachineData()
  },
  beforeDestroy() {
    delete window.onSerialData
    clearInterval(this.timer)
    clearInterval(this.timerData)
    // 清除串口超时计时器
    if (this.serialTimeoutTimer) {
      clearTimeout(this.serialTimeoutTimer)
    }
  },
  methods: {
    // ===================== 核心：判断设备是否在运行 =====================
    isItemRunning(item) {
      const s = item.speed
      if (s === undefined || s === null) return false
      const num = Number(s)
      // 速度 > 0 且不是 NaN、不是 - → 视为运行中
      return !isNaN(num) && num > 0
    },

    // ===================== 重新统计所有状态数量 =====================
    recalcStatusCount() {
      const list = this.overview.deviceInfo || []
      let run = 0
      let stop = 0
      let idle = 0
      let maintain = 0

      list.forEach(item => {
        if (this.isItemRunning(item)) {
          run++
        } else if (item.state === 0) {
          idle++
        } else if (item.state === -1) {
          stop++
        } else {
          idle++
        }
      })

      this.overview.yunXingCount = run
      this.overview.kongXianCount = idle
      this.overview.tingJiCount = stop
      // this.overview.baoYangCount = maintain // 如需保养逻辑可自己加
    },
    handler(payload) {

      // 增加V1，

      // 清除之前的超时计时器
      if (this.serialTimeoutTimer) {
        clearTimeout(this.serialTimeoutTimer)
      }
      const deviceId = payload.data.id  // 设备ID
      const v = Number(payload.data.v) // 速度
      if (v <= 99999) {
        this.serialData = payload.data.v
      }
      const currentC = Number(payload.data.c) // 日印刷数

      // ===================== 核心逻辑 =====================
      if (!isNaN(currentC)) {
        if (this.lastValidC == null) {
          // 第一次：直接赋值
          this.serialDataC = currentC
          this.lastValidC = currentC
        } else {
          // 比上次大 100 倍（两个量级）则丢弃本次
          if (currentC >= this.lastValidC * 100 || currentC < this.lastValidC) {
            console.log('数据异常（跳变/减小），丢弃：', currentC, '保留：', this.lastValidC)
          } else {
            // 正常更新
            this.serialDataC = currentC
            this.lastValidC = currentC
          }
        }
      }
      // ===================== 根据 ID 匹配设备，更新 count 和 speed =====================
      if (deviceId && this.overview.deviceInfo.length) {
        const target = this.overview.deviceInfo.find(item => item.id === deviceId)
        if (target) {
          target.speed = this.serialData    // 速度
          target.count = this.serialDataC  // 日印数

          // 每次更新设备后，重新计算总日印数
          this.overview.count = this.sumAllCount()
          // 接口加载完成后立刻重新统计状态
          this.recalcStatusCount()
        }
      }
      // 1 秒后没更新就置为 --
      this.serialTimeoutTimer = setTimeout(() => {
        this.serialData = '--'
        if (deviceId) {
          const target = this.overview.deviceInfo.find(item => item.id === deviceId)
          if (target) {
            target.speed = '--'
            // count 一般不清零，只清速度
            // 接口加载完成后立刻重新统计状态
            this.recalcStatusCount()
          }
        }
      }, 5000)
      // }
      console.log(this.serialData,this.serialTs,'--------2')
    },
    sumAllCount() {
      return this.overview.deviceInfo.reduce((sum, item) => {
        return sum + (Number(item.count) || 0)
      }, 0)
    },
    getDaPingJiTaiDaNaLi() {
      console.log(this.$route.query.teamId)
      API.DaPingJiTaiDaNaLi({teamId: this.$route.query.teamId}).then(res => {
        console.log(res)
        if(res.message.success) {
          this.overview = res.message.data
          // console.log(this.form)
          if (this.overview.date) {
            this.lastDateTime = new Date(this.overview.date).getTime()
          }
          // 加载完成后立刻计算一次总日印数
          this.overview.count = this.sumAllCount()
          // 接口加载完成后立刻重新统计状态
          this.recalcStatusCount()
        } else {
          console.log('------------------')
          console.error('接口调用失败', err);
        }

      }) .catch(err => {
        // 捕获错误但不做任何处理，就不会弹出提示
        console.error('接口调用失败', err)
      })

    },
    // 每秒 +1 秒并格式化
    addOneSecond() {
      if (!this.lastDateTime) return
      // 加 1000 毫秒
      this.lastDateTime += 1000
      // 格式化为 2026-06-13 15:09:36
      this.overview.date = this.formatDate(new Date(this.lastDateTime))
    },
    formatSpeed(speed) {
      const num = Number(speed)
      if (isNaN(num)) return '-'
      // 等于0直接返回0
      if (num === 0) return 0
      // 否则抹掉后两位
      return Math.floor(num / 100) * 100
    },
    // 日期格式化
    formatDate(date) {
      const y = date.getFullYear()
      const m = this.addZero(date.getMonth() + 1)
      const d = this.addZero(date.getDate())
      const h = this.addZero(date.getHours())
      const min = this.addZero(date.getMinutes())
      const s = this.addZero(date.getSeconds())
      return `${y}-${m}-${d} ${h}:${min}:${s}`
    },

    // 补零
    addZero(num) {
      return num < 10 ? '0' + num : num
    },
    currentTime(){
      setInterval(()=>{
        this.getDaPingJiTaiDaNaLi()
      },10000)
    },
  }
}
</script>

<style scoped lang="scss">

.wrapper {
  width: 100%;
  height: 100vh;
  background: #fff;
  padding: 16px;
  box-sizing: border-box;
}
.dashboard-wrap {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  background: #2b3c4c!important
}

// 顶部标题
.top-header {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 0 20px;
  .header-title {
    font-size: 54px;
    font-weight: bold;
    color: #fff;
    //background: -webkit-linear-gradient(#3268A6,#152E66);
    //-webkit-background-clip: text;
    //-webkit-text-fill-color: transparent;

  }
  .header-time {
    position: absolute;
    right: 10px;
    font-size: 24px;
    color: #fff;
    display: flex;
    .time-icon {
      margin-right: 8px;
    }
    img {
      width: 24px;
      margin-right: 10px;
    }
  }
}

.main-container {
  display: flex;
  gap: 10px;
  //height: calc(100% - 90px);
  background: linear-gradient(180deg, #2b3c4c 0%, #5a6672 100%);
  padding: 10px 20px 100px;
}

// 左侧侧边栏
.left-aside {
  width: 350px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
  background: #364f65;
  border-radius: 8px;
}
.aside-card {
  border-radius: 8px;
  padding: 24px 24px 0;
  .card-subtitle {
    font-size: 24px;
    color: #fff;
    position: relative;
    margin-bottom: 24px;
    line-height: 1;
    padding-left: 3px;
    font-weight: bold;

  }
  .card-subtitle2 {
    padding-top: 20px;
  }
  .card-box {
    //background: linear-gradient(180deg, #d7e8ff 0%, #f0f5fb 100%), #E3EEFC;
    background: linear-gradient(180deg, #2b3c4c 0%, #5a6672 100%);
  }
}
.aside-card:last-child{
  padding-top: 0;
}
// 设备总数模块
.total-device-box {
  position: relative;
  padding: 25px 15px 40px;
  background: #2b3d4b;
  border-radius: 8px;
  .total-text {
    font-size: 24px;
    color: #fff;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .total-num {
    font-size: 48px;
    font-weight: bold;
    color: #146bf8;
    line-height: 1;
    display: flex;
    align-items: end;
    justify-content: space-between;
    span{
      font-size: 24px;
      color: #fafafa;
    }
  }
  .cube-img {
    position: absolute;
    right: 0;
    top: 10px;
    width: 174px;
    height: 140px;
    //background: url("../assets/img/big-device.png") no-repeat center / contain;
  }
}
// 状态6宫格
.status-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 20px;
  .status-item {
    //border-radius: 6px;
    padding: 12px 8px;
    display: flex;
    flex-direction: column;
    //align-items: center;
    font-size: 20px;
    color: #fff;
    border-radius: 4px;
    //background: linear-gradient(180deg, #d7e8ff 0%, #f0f5fb 100%), #E3EEFC;
    background: linear-gradient(180deg, #2b3c4c 0%, #5a6672 100%);

    .num {
      font-size: 36px;
      font-weight: bold;
      display: flex;
      align-items: end;
      justify-content: space-between;
      span{
        font-size: 20px;
        color: #fff;
      }
    }
    .num.run { color: #39FF14; }
    .num.test { color: #146BF8; }
    .num.stop { color: #f53f3f; }
    .num.error { color: #f53f3f; }
    .num.maintain { color: #ff7d00; }
    .num.idle { color: #02D3FC; }

  }
}
// 日统计项
.stat-item {
  display: flex;
  //justify-content: space-between;
  align-items: center;
  font-size: 24px;
  margin: 25px 0;
  .stat-label {
    color: #fff;
    font-weight: bold;
    width: 200px;
    display: flex;
    align-items: center;
    img {
      width: 33px;
      margin-right: 10px;
    }
  }
  .stat-value {
    font-size: 28px;
    font-weight: bold;
    color: #39FF14;
  }
}

// 右侧设备3*3网格
.machine-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  align-content: start; // 网格整体靠顶部，不拉伸
  grid-auto-rows: auto; // 行高度由内容自动
}
.machine-grid.grid-4 {
  grid-template-columns: repeat(4, 1fr) !important;
}
.machine-card {
  //background: $light-card-bg;
  //background: linear-gradient(180deg, #2b3c4c 0%, #5a6672 100%);
  //border: 1px solid $border-color;
  border-radius: 8px;
  //padding: 20px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
  height: auto !important; // 卡片高度由内容撑开，不要撑满网格单元格
  .card-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding: 20px 20px 0;
    .machine-name {
      font-size: 24px;
      font-weight: bold;
      color: #fff;
    }
    .status-tag{
      padding: 4px 10px;
      border-radius: 4px;
      color: #000;
      font-size: 16px;

    }
    .status-tag.tag-run { background: #39FF14; }
    .status-tag.tag-test { background: #146BF8; }
    .status-tag.tag-idle { background: #37DEFF; }
    .status-tag.tag-stop { background: #f53f3f; }
    .status-tag.tag-error { background: #f53f3f; }
    .status-tag.tag-maintain { background: #ff7d00; }
  }
  .param-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 16px;
    gap: 5px;
    padding: 0 20px;
    .param-line {
      margin: 12px 0;
      color: #d2c9c9;
      div{
        width: 80px;
        display: inline-block;
      }
      span{
        color: #60B8FF;
        font-weight: bold;
      }
    }
    .border {
      border-left: 2px solid #39649e;
      line-height: 1;
      height: 82%;
      margin: auto 0;
    }
    .param-right {
      span{
        color: #fff;
        font-weight: bold;
      }
    }
  }
  .card-bottom-num {
    font-size: 56px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    margin-top: auto;
    //background: #D8E8FF;
    padding: 5px 0;
    background: linear-gradient(180deg, #2b3c4c 0%, #5a6672 100%);
  }
}
</style>

